import { createSingletonHook } from './createSingletonHook';

export const useIsScrollLocked = createSingletonHook<boolean>(false, (set) => {
  const checkIsScrollLocked = () => {
    set(document.body.hasAttribute('data-scroll-locked'));
  };

  const observer = new MutationObserver(checkIsScrollLocked);

  // Filter mutations for scroll locked attribute
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-scroll-locked'],
  });

  checkIsScrollLocked();

  return () => observer.disconnect();
});
